import { render, staticRenderFns } from "./QuotesActivities.vue?vue&type=template&id=3967bf06"
import script from "./QuotesActivities.vue?vue&type=script&lang=ts"
export * from "./QuotesActivities.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports